import { Outlet, useLocation, useNavigate, useParams } from "react-router";
import {
  Button,
  Col,
  Layout,
  Menu,
  Modal,
  Popover,
  Progress,
  Row,
  Tooltip,
} from "antd";
import React, { memo, useCallback, useEffect, useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import HeaderVer3 from "components/LayoutVer3/HeaderVer3";
// import ServiceIcon from "assets/icons/LayoutVer3/ServiceIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { loadUserDetail } from "redux/slices/user";
import {
  loadCategory,
  loadObjectCategory,
  updateIsHidden,
  updatePercent,
} from "redux/slices/objectsManagement";
import { getDefaultBrandName } from "redux/slices/brandName";
import { getAllSettingKnowledgeBase } from "redux/slices/knowledgeEnhancement";
import _ from "lodash";
import { getActiveQMView } from "redux/slices/QualityManagement";
import { loadAllObject } from "redux/slices/tenants";
import jwt from "jsonwebtoken";
import DashboardIcon, { routeActiveDashboard } from "./Icons/DashboardIcon";
import CalendarIcon, { routeActiveCalendar } from "./Icons/CalendarIcon";
import ReportIcon, { routeActiveReport } from "./Icons/ReportIcon";
import SettingIcon, { routeActiveSettings } from "./Icons/SettingIcon";
import LcmIcon, { routeActiveLcmIntegration } from "./Icons/LcmIcon";
// import MonitoringIcon, { routeActiveMonitoring } from "./Icons/MonitoringIcon";
import { routeActiveMonitoring } from "./Icons/MonitoringIcon";
import { storeDataCallCenter } from "redux/slices/callCenter";
import { unMountLogout } from "redux/slices/agentMonitor";
import AuthService from "services/AuthService";
import {
  REACT_APP_URL_TRACKING_LOGIN,
  USE_SSO,
  oidcClient,
} from "constants/constants";
import { logout, setCheckPermissionQMView } from "redux/slices/authenticated";
import useSignalR, { stopSignalR } from "services/useSignalR";
import { useTranslation, withTranslation } from "react-i18next";
import { CloseOutlined } from "@ant-design/icons";
import en from "assets/icons/LayoutVer3/EN.svg";
import vi from "assets/icons/common/vi.png";
import ModalVersion from "components/Modal/ModalVersion";
import CallCenterIcon, { routeActiveCallCenter } from "./Icons/CallCenterIcon";
// import QMIcon, { routeActiveQM } from "./Icons/QMIcon";
import { routeActiveQM } from "./Icons/QMIcon";
import ReloadIcon from "assets/icons/common/ReloadIcon.svg";
import CheckIcon from "assets/icons/common/CheckIcon.svg";
import MenuObject from "./Icons/MenuObject";
import { getListConfig, getSpecificUserStatus } from "redux/slices/agentStatus";
import { disconnectSignalRIC } from "redux/slices/icChatWidget";
import objFieldsPermissionAPI from "services/objFieldsPermissionAPI";
import { loadConfig } from "redux/slices/datetimeSetting";
import { InfoVersion } from "util/versionData";
import loadFormCreateService from "services/loadFormCreateAPI";
// import AgentMonitorIcon, {
//   routeActiveMAgentMonitor,
// } from "./Icons/AgentMonitorIcon";
import { routeActiveMAgentMonitor } from "./Icons/AgentMonitorIcon";
import getUserAsignRecordService from "services/getUserAsignRecordAPI";

const { Content, Sider } = Layout;

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label: (
      <Tooltip placement="rightTop" title={_.size(label) > 20 ? label : ""}>
        {label}
      </Tooltip>
    ),
    type,
    popupClassName: "custom-popup-sidebar",
  };
}

const LayoutVer3 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { startSignalR } = useSignalR();
  const { objectId, objectID } = useParams();
  const { i18n, t } = useTranslation();

  //state
  const [menu, setMenu] = useState([]);
  const [active, setActive] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [modalSignOut, setModalSignout] = useState(false);
  const [modalVersion, setModalVersion] = useState(false);
  const [language, setLanguage] = useState(
    localStorage.getItem("i18nextLng")
      ? localStorage.getItem("i18nextLng")
      : "vi"
  );

  //selector
  const { visibleList, objectCategory, percent, isHidden } = useSelector(
    (state) => state.objectsManagementReducer
  );
  const { userDetail, userRuleGlobal } = useSelector(
    (state) => state.userReducer
  );
  // const { title, checkPermissionQMView } = useSelector(
  //   (state) => state.authenticatedReducer
  // );
  const { title } = useSelector((state) => state.authenticatedReducer);
  const { activeQMView } = useSelector(
    (state) => state.qualityManagementReducer
  );
  const { interactionConfig: interactionConfigState } = useSelector(
    (state) => state.consolidatedViewSettingsReducer
  );
  const [lcmRule, setLcmRule] = useState(false);

  //function
  const onClick = (e) => {
    const listDefault = [
      "dashboard",
      "quality-management/default-view",
      "calendar",
      "report",
      "settings",
      "monitoring",
      "agents-monitor",
      "call-center",
      "lcm-integration",
    ];
    if (listDefault.includes(_.get(e, "key"))) {
      navigate(_.get(e, "key"));
    } else {
      if (
        _.get(e, "key") === "obj_quotations_00000001" ||
        _.get(e, "key") === "obj_quotation_items_00000001"
      ) {
        navigate("/sale-view/obj_quotations_00000001");
      } else if (
        _.get(e, "key") === "obj_opportunities_00000001" ||
        _.get(e, "key") === "obj_sale_orders_00000001"
      ) {
        navigate(`/sale-view/${_.get(e, "key")}`);
      } else if (_.get(e, "key") === "obj_products_00000001") {
        navigate(`/product-list`);
      } else {
        navigate(`objects/${_.get(e, "key")}/default-view`);
      }
    }

    setActive([_.get(e, "key")]);
  };

  const content = (
    <div style={{ width: "19rem" }}>
      <Row justify={"center"} style={{ width: "100%" }}>
        <CustomCol span={20}>
          <RowLanguage
            className={language === "vi" ? "active" : ""}
            onClick={() => {
              i18n.changeLanguage("vi");
              localStorage.setItem("i18nextLng", "vi");
              setLanguage("vi");
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                alt=""
                src={vi}
                style={{ width: "2.6rem", marginRight: "0.4rem" }}
              />
              Tiếng Việt
            </div>
            {language === "vi" && (
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.21662 14.9999C7.98565 14.9992 7.76534 14.9026 7.60828 14.7333L3.55829 10.4249C3.24302 10.089 3.25981 9.56104 3.59579 9.24578C3.93176 8.93052 4.45969 8.94731 4.77495 9.28328L8.20828 12.9416L15.2166 5.27495C15.4104 5.03363 15.722 4.91959 16.0258 4.97879C16.3296 5.03799 16.5755 5.26068 16.6645 5.55711C16.7535 5.85354 16.6709 6.17487 16.45 6.39162L8.83328 14.7249C8.67769 14.8974 8.45719 14.9971 8.22495 14.9999H8.21662Z"
                  fill="#36B37E"
                />
              </svg>
            )}
          </RowLanguage>

          <RowLanguage
            className={language === "en" ? "active" : ""}
            onClick={() => {
              i18n.changeLanguage("en");
              localStorage.setItem("i18nextLng", "en");
              setLanguage("en");
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                alt=""
                src={en}
                style={{ width: "2.6rem", marginRight: "0.4rem" }}
              />
              English
            </div>
            {language === "en" && (
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.21662 14.9999C7.98565 14.9992 7.76534 14.9026 7.60828 14.7333L3.55829 10.4249C3.24302 10.089 3.25981 9.56104 3.59579 9.24578C3.93176 8.93052 4.45969 8.94731 4.77495 9.28328L8.20828 12.9416L15.2166 5.27495C15.4104 5.03363 15.722 4.91959 16.0258 4.97879C16.3296 5.03799 16.5755 5.26068 16.6645 5.55711C16.7535 5.85354 16.6709 6.17487 16.45 6.39162L8.83328 14.7249C8.67769 14.8974 8.45719 14.9971 8.22495 14.9999H8.21662Z"
                  fill="#36B37E"
                />
              </svg>
            )}
          </RowLanguage>
        </CustomCol>
      </Row>
    </div>
  );

  const SetMenu = useCallback(() => {
    let object;
    if (objectCategory) {
      const CloneObjectCategory = { ...objectCategory };

      object = Object.entries(
        CloneObjectCategory !== null && CloneObjectCategory
        /*eslint-disable-next-line*/
      ).map(([key, value]) => {
        if (visibleList[key]) {
          let listObject = [];
          value.forEach((item) => {
            if (_.get(item, "visible") && _.get(item, "Status")) {
              if (
                item._id !== "obj_segment_00000001" &&
                item._id !== "obj_quotation_items_00000001" &&
                item._id !== "obj_sale_order_items_00000001" &&
                item._id !== "obj_segment_member_00000001"
              )
                listObject.push(
                  getItem(_.get(item, "Name"), _.get(item, "_id"))
                );
            }
          });

          return getItem(
            `${key} (${_.size(listObject)})`,
            key,
            null,
            listObject
          );
        }
      });
    }

    // const checkRule = (setting) => {
    //   if (
    //     userRuleGlobal.find(
    //       (item) =>
    //         _.get(item, "domain", "") === setting &&
    //         item.actions.includes("view")
    //     )
    //   )
    //     return true;
    //   else return false;
    // };

    const commonMenuItems = [
      getItem(t("common.dashboard"), "dashboard", <DashboardIcon />),
      ...(object
        ? [getItem(t("common.object"), "objects", <MenuObject />, object)]
        : []),
      // ...(checkPermissionQMView
      //   ? [
      //       getItem(
      //         t("common.qualityManagement"),
      //         "quality-management/default-view",
      //         <QMIcon />
      //       ),
      //     ]
      //   : []),
      getItem(t("common.calendar"), "calendar", <CalendarIcon />),
      getItem(t("common.reports"), "report", <ReportIcon />),
      // getItem("Monitoring", "monitoring", <MonitoringIcon />),
      // ...(checkRule("agent_monitor")
      //   ? [
      //       getItem(
      //         t("settings.agentsMonitor"),
      //         "agents-monitor",
      //         <AgentMonitorIcon />
      //       ),
      //     ]
      //   : []),
      ...(userDetail && (userDetail.use_cti || userDetail.use_ic)
        ? [getItem("Call Center", "call-center", <CallCenterIcon />)]
        : []),
      ...(userDetail && userRuleGlobal && _.size(userRuleGlobal) > 0
        ? [getItem(t("common.settings"), "settings", <SettingIcon />)]
        : []),
      ...(lcmRule
        ? [getItem("LCM Integration", "lcm-integration", <LcmIcon />)]
        : []),
    ];

    setMenu([...[getItem("", "grp", null, commonMenuItems, "group")]]);
  }, [
    t,
    // checkPermissionQMView,
    objectCategory,
    userDetail,
    userRuleGlobal,
    visibleList,
    lcmRule,
  ]);

  //useEffect
  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    SetMenu();
  }, [SetMenu]);

  useEffect(() => {
    let userDetail = jwt.decode(localStorage.getItem("setting_accessToken"));
    if (userDetail) {
      dispatch(
        loadUserDetail({
          _id: userDetail.crm_claims
            ? JSON.parse(userDetail.crm_claims).ID
            : userDetail.ID,
        })
      );
    }

    // eslint-disable-next-line
  }, [pathname]);

  useEffect(() => {
    dispatch(loadCategory());
    dispatch(loadObjectCategory());
    dispatch(getDefaultBrandName());
    dispatch(getAllSettingKnowledgeBase());
    dispatch(getListConfig());
    dispatch(getSpecificUserStatus());
    dispatch(loadConfig());
  }, [dispatch]);

  useEffect(() => {
    if (_.get(userDetail, "tenant_id")) {
      // dispatch(interactionConfig());
      dispatch(getActiveQMView());
      dispatch(
        loadAllObject({
          tenant_id: _.get(userDetail, "tenant_id"),
        })
      );
    }
  }, [dispatch, userDetail]);

  useEffect(() => {
    if (AuthService) {
      AuthService.eventSignOut(() => {
        if (
          JSON.parse(localStorage.getItem("icIntegration_useIC")) === true &&
          localStorage.getItem("icIntegration_connection_ids")
        ) {
          stopSignalR();
          dispatch(
            disconnectSignalRIC({
              connection_ids: JSON.parse(
                localStorage.getItem("icIntegration_connection_ids")
              )?.join(","),
            })
          );
        } else {
          localStorage.removeItem("icIntegration_connection_ids");
          localStorage.removeItem("icIntegration_link_api");
          localStorage.removeItem("icIntegration_accessToken");
        }

        setModalSignout(true);
        localStorage.removeItem("setting_accessToken");
        localStorage.removeItem("setting_refreshToken");
        localStorage.removeItem("themeColor");
        localStorage.removeItem("i18nextLng");
        localStorage.removeItem("redux-root");
        localStorage.removeItem("settings");
        localStorage.removeItem("@ucrm_callCenter_pageIsOpen");
        localStorage.removeItem("@ucrm_callCenter_data");
        localStorage.removeItem("@ucrm_callCenter_phoneInCall");
        localStorage.removeItem("@ucrm_callCenter_interactionDetails");
        localStorage.removeItem(
          "@ucrm_callCenter_tablInfoSearchSelect_obj_interaction_00000001"
        );
        localStorage.removeItem("@ucrm_callCenter_syncedCore");
        localStorage.removeItem("@ucrm_callCenter_firstLoad");
        dispatch(
          storeDataCallCenter({
            dataCallCenter: [],
            phoneInCall: "",
            syncedCore: [],
          })
        );
        dispatch(unMountLogout());
        objFieldsPermissionAPI.clearCache();
        loadFormCreateService.clearCache();
        getUserAsignRecordService.clearCache();

        // dispatch(logout())
        // navigate('/login')
      });
      AuthService.eventAddAccessTokenExpiring();
      AuthService.eventAddAccessTokenExpired();
      AuthService.eventAddUserLoaded();
      AuthService.eventAddSilentRenewError();

      //Cập nhật lại thông tin user vào sessionStorage
      if (window.addEventListener)
        window.addEventListener(
          "storage",
          () => {
            sessionStorage.setItem(
              `oidc.user:${oidcClient.stsAuthority}:${oidcClient.clientId}`,
              localStorage.getItem("setting_oidc")
            );
          },
          false
        );
    }
  }, [dispatch]);

  useEffect(() => {
    if (
      objectCategory &&
      activeQMView &&
      typeof objectCategory === "object" &&
      !Array.isArray(objectCategory)
    ) {
      let temp = [];
      temp = _.flatMap(Object.values(objectCategory));

      let permissionQM = temp.find(
        (item) => _.get(item, "_id") === "obj_crm_qm_interaction_00001"
      );

      // let permissionInteraction;
      // if (interactionConfigState) {
      //   permissionInteraction = temp.find(
      //     (item) =>
      //       _.get(item, "_id") === _.get(interactionConfigState, "object_id")
      //   );
      // }

      const checkPermission =
        permissionQM &&
        _.get(permissionQM, "Status", false) &&
        _.get(permissionQM, "visible", false);
      // &&
      // permissionInteraction &&
      // _.get(permissionInteraction, "Status", false) &&
      // _.get(permissionInteraction, "visible", false);

      dispatch(
        setCheckPermissionQMView(
          checkPermission &&
            _.get(activeQMView, "active", false) &&
            _.get(activeQMView, "active_root", false)
        )
      );
    }
  }, [objectCategory, interactionConfigState, activeQMView, dispatch]);

  useEffect(() => {
    async function runSignalr() {
      await startSignalR();
    }
    setTimeout(() => {
      runSignalr();
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      objectId &&
      pathname.split("/")[1] === "objects" &&
      objectId === pathname.split("/")[2]
    ) {
      setActive([objectId]);
    } else {
      if (routeActiveDashboard.includes(pathname.split("/")[1])) {
        setActive(["dashboard"]);
      } else if (routeActiveQM.includes(pathname.split("/")[1])) {
        setActive(["quality-management/default-view"]);
      } else if (routeActiveCalendar.includes(pathname.split("/")[1])) {
        setActive(["calendar"]);
      } else if (routeActiveReport.includes(pathname.split("/")[1])) {
        setActive(["report"]);
      } else if (routeActiveMonitoring.includes(pathname.split("/")[1])) {
        setActive(["monitoring"]);
      } else if (routeActiveMAgentMonitor.includes(pathname.split("/")[1])) {
        setActive(["agents-monitor"]);
      } else if (routeActiveSettings.includes(pathname.split("/")[1])) {
        setActive(["settings"]);
      } else if (routeActiveCallCenter.includes(pathname.split("/")[1])) {
        setActive(["call-center"]);
      } else if (routeActiveLcmIntegration.includes(pathname.split("/")[1])) {
        setActive(["lcm-integration"]);
      } else if (pathname.split("/")[1] === "product-list") {
        setActive(["obj_products_00000001"]);
      } else if (pathname.split("/")[1] === "sale-view") {
        setActive([objectID]);
      } else {
        setActive([pathname.split("/")[1]]);
      }
    }
  }, [pathname, objectId, objectID]);

  useEffect(() => {
    let temp = [];
    Object.entries(objectCategory).forEach(([key, value]) => {
      value.forEach((item) => {
        temp.push(item._id);
      });
    });
    if (
      temp.includes("obj_segment_00000001") &&
      temp.includes("obj_segment_member_00000001")
    ) {
      setLcmRule(true);
    } else {
      setLcmRule(false);
    }
  }, [objectCategory]);

  return (
    <CustomLayout>
      <GlobalStyle />
      {userDetail._id && USE_SSO === "true" ? (
        <iframe
          src={
            REACT_APP_URL_TRACKING_LOGIN +
            "?userName=" +
            userDetail.Email +
            "&userID=" +
            userDetail._id +
            "&baseAppName=CRM"
          }
          title={"tracking-user-login"}
          style={{ display: "none" }}
        ></iframe>
      ) : (
        ""
      )}
      <CustomHeader collapsed={collapsed} />
      <CustomLayout>
        <CustomSider
          trigger={null}
          collapsible
          collapsed={collapsed}
          className={collapsed ? "collapsed" : ""}
        >
          <div>
            <Menu
              onClick={onClick}
              selectedKeys={active}
              mode="inline"
              items={menu}
              theme="light"
              triggerSubMenuAction="click"
            />
          </div>
          <FooterSidebar className={collapsed ? "collapsed" : ""}>
            <div className="version_app" onClick={() => setModalVersion(true)}>
              V {_.get(InfoVersion, "[0].version")}
            </div>
            <Popover
              placement="rightBottom"
              content={content}
              trigger={"click"}
              overlayClassName="popoverSidebar"
            >
              <div className="language_app">
                <img
                  alt=""
                  src={language === "vi" ? vi : en}
                  style={{
                    width: "2.8rem",
                    height: "1.8rem",
                    objectFit: "cover",
                  }}
                />
                <div
                  className={
                    collapsed ? "collapsed language_title" : "language_title"
                  }
                >
                  {language === "vi" ? "Tiếng Việt" : "English"}
                </div>
              </div>
            </Popover>
          </FooterSidebar>
        </CustomSider>
        <CollapseIcon
          onClick={() => setCollapsed((pre) => !pre)}
          className={collapsed ? "collapsed" : ""}
        >
          <svg
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.717593 5.47086L5.96759 0.220857C6.09988 0.087981 6.27713 0.00947223 6.46443 0.000802786C6.65172 -0.00786666 6.83547 0.053932 6.97947 0.17402C7.12346 0.294108 7.21725 0.463774 7.24235 0.649582C7.26746 0.835391 7.22205 1.02386 7.11509 1.17786L7.02959 1.28136L2.31059 6.00036L7.03109 10.7209C7.16397 10.8531 7.24248 11.0304 7.25115 11.2177C7.25982 11.405 7.19802 11.5887 7.07793 11.7327C6.95784 11.8767 6.78818 11.9705 6.60237 11.9956C6.41656 12.0207 6.22809 11.9753 6.07409 11.8684L5.96909 11.7814L0.719093 6.53136C0.59508 6.40707 0.5186 6.24322 0.502977 6.06835C0.487353 5.89347 0.533576 5.71866 0.633593 5.57436L0.719093 5.46936L0.717593 5.47086Z"
              fill="#637381"
            />
            <path
              d="M5.71759 5.47086L10.9676 0.220857C11.0999 0.087981 11.2771 0.00947223 11.4644 0.000802786C11.6517 -0.00786666 11.8355 0.053932 11.9795 0.17402C12.1235 0.294108 12.2172 0.463774 12.2424 0.649582C12.2675 0.835391 12.2221 1.02386 12.1151 1.17786L12.0296 1.28136L7.31059 6.00036L12.0311 10.7209C12.164 10.8531 12.2425 11.0304 12.2511 11.2177C12.2598 11.405 12.198 11.5887 12.0779 11.7327C11.9578 11.8767 11.7882 11.9705 11.6024 11.9956C11.4166 12.0207 11.2281 11.9753 11.0741 11.8684L10.9691 11.7814L5.71909 6.53136C5.59508 6.40707 5.5186 6.24322 5.50298 6.06835C5.48735 5.89347 5.53358 5.71866 5.63359 5.57436L5.71909 5.46936L5.71759 5.47086Z"
              fill="#637381"
            />
          </svg>
        </CollapseIcon>
        <CustomLayout>
          <CustomContent>
            <Outlet />
          </CustomContent>
        </CustomLayout>
      </CustomLayout>

      {/* Modal */}
      <Modal
        visible={modalSignOut}
        footer={[
          <Button
            onClick={() => {
              dispatch(logout());
              navigate("/login");
            }}
          >
            Ok
          </Button>,
        ]}
      >
        <p> Vui lòng đăng nhập lại</p>
      </Modal>
      <ModalVersion
        modalVersion={modalVersion}
        setModalVersion={setModalVersion}
      />

      <NotiCheckUpdate isHidden={isHidden}>
        <img src={percent === 100 ? CheckIcon : ReloadIcon} alt="" />
        <Status>
          <p>{t("object.checkingForUpdate")}</p>
          <Progress percent={percent} showInfo={false} size="small" />
          <span>
            {percent === 100
              ? t("object.updateSuccess")
              : t("object.pleaseWait")}
          </span>
          <CloseOutlined
            style={{ display: percent === 100 ? "block" : "none" }}
            onClick={() => {
              dispatch(updateIsHidden(true));
              dispatch(updatePercent(0));
            }}
          />
        </Status>
      </NotiCheckUpdate>
    </CustomLayout>
  );
};

export default withTranslation()(memo(LayoutVer3));

const RowLanguage = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  padding: 0.8rem;
  border-radius: 0.6rem;

  &.active {
    background-color: #f4f6f8;
  }
`;

const FooterSidebar = styled.div`
  .language_app {
    padding: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    border-top: 0.1rem solid #dfe3e8;
    cursor: pointer;

    .language_title.collapsed {
      opacity: 0;
      max-height: 0;
      max-width: 0;
      overflow: hidden;
      transition: all 0.5s ease;
    }

    .language_title {
      opacity: 1;
      max-width: 10rem;
      transition: all 0.5s ease;
      max-height: 3.5rem;
    }
  }

  &.collapsed {
    .language_app {
      gap: 0.2rem;
    }
  }

  .version_app {
    font-size: 1.3rem;
    font-family: var(--roboto-400);
    line-height: 1.8rem;
    text-align: center;
    color: ${(props) => props.theme.main};
    padding: 1.2rem 0;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const GlobalStyle = createGlobalStyle`
 .ant-menu-title-content {
      font-size: 1.3rem !important;
      font-family: var(--roboto-500);
    }
  .custom-popup-sidebar {
    .ant-menu-title-content {
      font-size: 1.3rem !important;
    }

    .ant-menu {
      &:not(:empty) {
          padding: 0.8rem 0;
      }
        .ant-menu-item {
          margin: 0;
          &.ant-menu-item-selected {
            .ant-menu-title-content {
              transition: all 0.2s ease;
              color: #212b36 !important;
              font-family:var(--roboto-400);
              font-family: var(--roboto-700);
            }
          }

          .ant-menu-title-content {
              color: #212B36 !important;
              transition: all 0.2s ease;
              font-size: 1.3rem;
              font-family:var(--roboto-500);
              text-align: left;

              &:hover {
                transition: all 0.1s ease;
                color: #212b36 !important;
              }
            }


                position: relative;
                padding-left: 3rem !important;

                &.ant-menu-item-selected {
                  background: transparent !important;

                  &::before {
                    width: 0.8rem;
                    height: 0.8rem;
                    background: ${(props) => props.theme.main} !important;
                    left: 1.3rem;
                    transition: 0.2s all ease;
                  }
                }

                &::before {
                  content: "";
                  transition: 0.2s all ease;
                  width: 0.4rem;
                  height: 0.4rem;
                  border-radius: 50%;
                  position: absolute;
                  top: 50%;
                  transform: translateY(-50%);
                  left: 1.6rem;
                  background: #212B36;
                }
              }


      .ant-menu-submenu {
        padding: 0.4rem 1.2rem;
          .ant-menu-submenu-title {
              padding-left: 3rem;
                  margin: 0;
                  background-color: transparent !important;
                  font-family:var(--roboto-500);
                  border-radius: 0.6rem;

                  .ant-menu-title-content {
                    color: #212B36 !important;

                    &:hover {
                      color: #212b36 !important;
                    }
                  }

                  &:hover {
                    background-color: #919eab29 !important;
                  }

                  .ant-menu-submenu-arrow {
                    display: block !important;

                    &::before {
                      background-color: #212B36;
                    }
                    &::after {
                      background-color: #212B36;
                    }
                  }

                  &::before {
                    content: "";
                    transition: 0.2s all ease;
                    width: 1rem;
                    height: 1rem;
                    border-radius: 50%;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 1.2rem;
                    border: 0.1rem solid #212B36;
                  }

                


                }
              }

              .ant-menu-submenu.ant-menu-submenu-selected {
                .ant-menu-submenu-title {
                  background-color: ${(props) => {
                    const hex = props.theme.main.replace(/^#/, "");
                    const bigint = parseInt(hex, 16);
                    const r = (bigint >> 16) & 255;
                    const g = (bigint >> 8) & 255;
                    const b = bigint & 255;

                    return `rgba(${r}, ${g}, ${b}, 0.15) !important`;
                  }};
                  font-family:var(--roboto-500);

                  .ant-menu-title-content {
                    color: ${(props) => props.theme.main} !important;
                    font-family: var(--roboto-700);
                  }

                  .ant-menu-submenu-arrow {
                    display: none !important;
                  }

                  &::before {
                    border: 0.1rem solid ${(props) => props.theme.main};
                  }
                }
              }

              .ant-menu-submenu.ant-menu-submenu-open {
                .ant-menu-submenu-title {
                  background-color: ${(props) => {
                    const hex = props.theme.main.replace(/^#/, "");
                    const bigint = parseInt(hex, 16);
                    const r = (bigint >> 16) & 255;
                    const g = (bigint >> 8) & 255;
                    const b = bigint & 255;

                    return `rgba(${r}, ${g}, ${b}, 0.15) !important`;
                  }};
                  font-family:var(--roboto-500);

                  .ant-menu-title-content {
                    color: ${(props) => props.theme.main} !important;
                    font-family: var(--roboto-700);
                  }

                  .ant-menu-submenu-arrow {
                    display: none !important;
                  }

                  &::before {
                    border: 0.1rem solid ${(props) => props.theme.main};
                  }
                }
              }
    }
  }

  .ant-btn.ant-btn-primary.ant-btn-sm {
    border-color:  ${(props) => props.theme.main};
    background:  ${(props) => props.theme.main};
  }
`;

const Status = styled.div`
  position: relative;
  width: 34.6rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0rem 1.2rem;
  p {
    margin-bottom: 0rem;
    font-size: 1.6rem;
    font-family: var(--roboto-500);
  }
  span {
    font-size: 1.3rem;
    color: #212b36;
  }
  .ant-progress {
    line-height: 0;
    margin: 0.1rem 0rem 0.2rem 0rem;
  }
  .ant-progress-status-success .ant-progress-bg {
    background-color: #1890ff;
  }
  .ant-progress-outer {
    transition: width 2s;
  }
  svg {
    position: absolute;
    top: 0;
    right: -1.3rem;
    width: 2rem;
    color: #919eab;
    cursor: pointer;
  }
`;

const NotiCheckUpdate = styled.div`
  box-shadow: 0rem 0.8rem 1.6rem 0rem rgba(0, 0, 0, 0.05);
  position: absolute;
  bottom: 5rem;
  right: 2.2rem;
  z-index: 100;
  display: flex;
  align-items: center;
  padding: 1.2rem;
  border-radius: 0.6rem;
  background: #fff;
  transition: all 1s;
  opacity: ${(props) => (props.isHidden ? 0 : 1)};
  visibility: ${(props) => (props.isHidden ? "hidden" : "visible")};
  display: ${(props) => (props.isHidden ? "none" : "flex")};
  img {
    width: 4.8rem;
    height: 4.8rem;
  }
`;

const CustomHeader = styled(HeaderVer3)`
  box-shadow: rgba(0, 0, 0, 0.05) 0rem 0.4rem 1rem;
  z-index: 1;
`;

const CustomLayout = styled(Layout)`
  position: inherit;
`;

const CustomSider = styled(Sider)`
  box-shadow: 0.4rem 0.8rem 0.8rem 0rem rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 5.2rem;
  left: 0;
  z-index: 9;
  height: calc(100vh - 5.2rem);
  min-height: calc(100vh - 5.2rem);
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
  padding: 4.5rem 0 0 0;

  flex: 0 0 22rem !important;
  max-width: 22rem !important;
  min-width: 22rem !important;
  width: 22rem !important;
  transition: 0.2s all ease;

  ::-webkit-scrollbar {
    display: none;
  }

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    justify-content: space-between !important;
    .ant-menu {
      border: none;
      .ant-menu-item-group {
        .ant-menu-item-group-title {
          display: none;
          font-size: 1.2rem;
          font-family: var(--roboto-700);
          line-height: 1.8rem;
          text-align: left;
          color: #212b36 !important;
          padding-left: 3rem;
        }

        .ant-menu-item-group-list {
          .ant-menu-submenu-inline {
            padding-right: 1.2rem;
          }

          .ant-menu-item.ant-menu-item-selected {
            background-color: ${(props) => {
              const hex = props.theme.main.replace(/^#/, "");
              const bigint = parseInt(hex, 16);
              const r = (bigint >> 16) & 255;
              const g = (bigint >> 8) & 255;
              const b = bigint & 255;

              return `rgba(${r}, ${g}, ${b}, 0.15) !important`;
            }};

            color: ${(props) => props.theme.main} !important;
            font-size: 1.3rem;
            font-family: var(--roboto-500);
            transition: all 0.2s ease;

            .ant-menu-title-content {
              margin-left: 1.6rem;
              color: ${(props) => props.theme.main} !important;
              font-family: var(--roboto-700);
            }
          }

          .ant-menu-item.ant-menu-item-selected.ant-menu-item-only-child {
            background-color: ${(props) => {
              const hex = props.theme.main.replace(/^#/, "");
              const bigint = parseInt(hex, 16);
              const r = (bigint >> 16) & 255;
              const g = (bigint >> 8) & 255;
              const b = bigint & 255;

              return `rgba(${r}, ${g}, ${b}, 0.15) !important`;
            }};

            color: ${(props) => props.theme.main} !important;
            font-size: 1.3rem;
            font-family: var(--roboto-500);
            transition: all 0.2s ease;

            .ant-menu-title-content {
              margin-left: 1.6rem;
              color: #212b36 !important;
              font-family: var(--roboto-500);
            }
          }

          .ant-menu-item {
            height: 4.8rem;
            width: calc(100% - 1.2rem);
            margin-left: auto;
            margin-right: auto;
            background-color: transparent;
            transition: all 0.2s ease;
            border-radius: 0.8rem;
            padding-left: 1.6rem !important;

            &:hover {
              transition: all 0.2s ease;
              background: #919eab29;
            }

            &::after {
              display: none;
            }
            .ant-menu-title-content {
              margin-left: 1.6rem;
              color: #212b36;
              transition: all 0.2s ease;
              font-size: 1.3rem;
              font-family: var(--roboto-500);
              text-align: left;

              &:hover {
                transition: all 0.1s ease;
                color: #212b36;
              }
            }

            div {
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }

          .ant-menu-submenu.ant-menu-submenu-open {
            .ant-menu-submenu-title {
              .iconObject {
                width: fit-content;
                svg {
                  path {
                    fill: ${(props) => props.theme.main || "#212B36"};
                  }
                  rect {
                    fill: ${(props) => props.theme.main || "#212B36"};
                  }

                  circle {
                    fill: ${(props) => props.theme.main || "#212B36"};
                  }
                }

                .object_icon_active {
                  display: block !important;
                }

                .object_icon {
                  display: none !important;
                }
              }
            }

            .ant-menu-submenu-title {
              background-color: ${(props) => {
                const hex = props.theme.main.replace(/^#/, "");
                const bigint = parseInt(hex, 16);
                const r = (bigint >> 16) & 255;
                const g = (bigint >> 8) & 255;
                const b = bigint & 255;

                return `rgba(${r}, ${g}, ${b}, 0.15) !important`;
              }};
              font-family: var(--roboto-500);
              border-radius: 0.6rem;

              .ant-menu-title-content {
                color: ${(props) => props.theme.main} !important;
              }

              .ant-menu-submenu-arrow {
                display: none;
              }
            }

            .ant-menu.ant-menu-inline {
              margin-top: 0.4rem;
            }

            .ant-menu {
              .ant-menu-submenu {
                .ant-menu-submenu-title {
                  background-color: transparent !important;
                  font-family: var(--roboto-500);

                  .ant-menu-title-content {
                    color: #212b36 !important;

                    &:hover {
                      color: #212b36 !important;
                    }
                  }

                  &:hover {
                    background-color: #919eab29 !important;
                    border-radius: 0.6rem;
                  }

                  .ant-menu-submenu-arrow {
                    display: block !important;
                  }

                  &::before {
                    content: "";
                    transition: 0.2s all ease;
                    width: 1rem;
                    height: 1rem;
                    border-radius: 50%;
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 1.2rem;
                    border: 0.1rem solid #212b36;
                  }
                }
                /* background-color: red !important; */
              }

              .ant-menu-submenu.ant-menu-submenu-selected {
                .ant-menu-submenu-title {
                  background-color: ${(props) => {
                    const hex = props.theme.main.replace(/^#/, "");
                    const bigint = parseInt(hex, 16);
                    const r = (bigint >> 16) & 255;
                    const g = (bigint >> 8) & 255;
                    const b = bigint & 255;

                    return `rgba(${r}, ${g}, ${b}, 0.15) !important`;
                  }};
                  font-family: var(--roboto-500);
                  border-radius: 0.6rem;

                  .ant-menu-title-content {
                    color: ${(props) => props.theme.main} !important;
                  }

                  .ant-menu-submenu-arrow {
                    display: none !important;
                  }

                  &::before {
                    border: 0.1rem solid ${(props) => props.theme.main};
                  }
                }
              }
              .ant-menu-submenu.ant-menu-submenu-open {
                .ant-menu-submenu-title {
                  background-color: ${(props) => {
                    const hex = props.theme.main.replace(/^#/, "");
                    const bigint = parseInt(hex, 16);
                    const r = (bigint >> 16) & 255;
                    const g = (bigint >> 8) & 255;
                    const b = bigint & 255;

                    return `rgba(${r}, ${g}, ${b}, 0.15) !important`;
                  }};
                  font-family: var(--roboto-500);
                  border-radius: 0.6rem;

                  .ant-menu-title-content {
                    color: ${(props) => props.theme.main} !important;
                    font-family: var(--roboto-700);
                  }

                  .ant-menu-submenu-arrow {
                    display: none !important;
                  }

                  &::before {
                    border: 0.1rem solid ${(props) => props.theme.main};
                  }
                }
              }
            }
          }

          .ant-menu-submenu.ant-menu-submenu-vertical {
            width: calc(100% - 1.2rem);

            .ant-menu-submenu-title {
              padding-left: 2rem !important;
            }
          }

          .ant-menu-submenu.ant-menu-submenu-vertical.ant-menu-submenu-open {
            .ant-menu-submenu-title {
              .iconObject {
                margin-left: 0.8rem !important;
              }
            }
          }

          .ant-menu-submenu {
            min-height: 4.8rem;
            margin-left: 0.6rem;
            margin-bottom: 0.8rem;
            margin-top: 0.4rem;

            .ant-menu-submenu-title {
              height: 100%;
              padding: 0 2rem;
              margin: 0;
              padding-left: 1.6rem !important;
              height: 4.8rem;

              &:hover {
                background-color: #919eab29;
                border-radius: 0.6rem;
              }

              .ant-menu-title-content {
                color: #212b36;
                padding-left: 1.6rem !important;
              }

              .ant-menu-submenu-arrow {
                right: 1rem;
                transform: rotate(-90deg);
                top: 45% !important;

                &::before {
                  background-color: #212b36 !important;
                }
                &::after {
                  background-color: #212b36 !important;
                }
              }

              &:hover {
                .ant-menu-title-content {
                  color: #212b36;
                  /* font-family:var(--roboto-500); */
                }
              }
            }

            &.ant-menu-submenu-selected {
              .ant-menu-submenu-title {
                .iconObject {
                  svg {
                    path {
                      fill: ${(props) => props.theme.main || "#212B36"};
                    }
                    rect {
                      fill: ${(props) => props.theme.main || "#212B36"};
                    }

                    circle {
                      fill: ${(props) => props.theme.main || "#212B36"};
                    }
                  }

                  .object_icon_active {
                    display: block !important;
                  }

                  .object_icon {
                    display: none !important;
                  }
                }
              }
              font-family: var(--roboto-500);

              /* border-radius: 0.6rem 0 0 0.6rem; */
              border-radius: 0.6rem;

              .ant-menu {
                background-color: #fff;
              }

              .ant-menu-submenu-title {
                background-color: ${(props) => {
                  const hex = props.theme.main.replace(/^#/, "");
                  const bigint = parseInt(hex, 16);
                  const r = (bigint >> 16) & 255;
                  const g = (bigint >> 8) & 255;
                  const b = bigint & 255;

                  return `rgba(${r}, ${g}, ${b}, 0.15) !important`;
                }};
                border-radius: 0.6rem;

                .ant-menu-title-content {
                  color: ${(props) => props.theme.main} !important;
                }

                /* .ant-menu-submenu-arrow {
                  &::before {
                    background-color: ${(props) => props.theme.main} !important;
                  }
                  &::after {
                    background-color: ${(props) => props.theme.main} !important;
                  }
                } */
              }
            }

            .ant-menu {
              background-color: transparent;
              .ant-menu-item {
                position: relative;
                padding-left: 1.2rem !important;

                &.ant-menu-item-selected {
                  background: transparent !important;

                  &::before {
                    width: 0.8rem;
                    height: 0.8rem;
                    background: ${(props) => props.theme.main} !important;
                    left: 1rem;
                    transition: 0.2s all ease;
                  }
                }

                &::before {
                  content: "";
                  transition: 0.2s all ease;
                  width: 0.4rem;
                  height: 0.4rem;
                  border-radius: 50%;
                  position: absolute;
                  top: 50%;
                  transform: translateY(-50%);
                  left: 1.2rem;
                  background: #212b36;
                }
              }
            }
          }
        }
      }

      .ant-menu-item-group {
        &:first-child {
        }

        &:last-child {
          .ant-menu-item-group-list {
            max-height: calc(100vh - 19rem);
            min-height: 10rem;

            overflow-y: auto;
            overflow-x: hidden;

            ::-webkit-scrollbar {
              display: none;
            }
          }
        }
      }
    }
  }

  &.collapsed {
    flex: 0 0 8.8rem !important;
    max-width: 8.8rem !important;
    min-width: 8.8rem !important;
    width: 8.8rem !important;
    transition: 0.2s all ease;

    .ant-layout-sider-children {
      .ant-menu {
        .ant-menu-item-group {
          .ant-menu-item-group-title {
            display: none;
          }

          .ant-menu-item-group-list {
            .ant-menu-item {
              padding: 0 1.6rem;
            }

            .ant-menu-submenu {
              &.ant-menu-submenu-selected {
                color: ${(props) => props.theme.main} !important;
                font-family: var(--roboto-500);
                background-color: ${(props) => {
                  const hex = props.theme.main.replace(/^#/, "");
                  const bigint = parseInt(hex, 16);
                  const r = (bigint >> 16) & 255;
                  const g = (bigint >> 8) & 255;
                  const b = bigint & 255;

                  return `rgba(${r}, ${g}, ${b}, 0.15) !important`;
                }};
                /* border-radius: 0.6rem 0 0 0.6rem; */
                border-radius: 0.6rem;
              }
            }
          }
        }

        .ant-menu-item-group {
          &:last-child {
            /* position: relative; */
            /* padding-top: 1.6rem; */

            .ant-menu-item-group-list {
              max-height: initial;
              overflow-y: auto;
              overflow-x: hidden;
            }

            /* &::after {
              width: 50%;
              height: 0.1rem;
              content: "";
              background-color: #ccd4dd;
              position: absolute;
              top: 0.5rem;
              left: 50%;
              transform: translateX(-50%);
            } */
          }
        }
      }
    }
  }
`;

const CustomContent = styled(Content)`
  padding: 0;
  margin: 0;
  height: calc(100vh - 5.2rem);
  overflow-y: auto;
  filter: blur(0rem);
  transition: 0.2s all;
  position: inherit;
  background-color: ${(props) =>
    window.location.pathname.includes("/objects/") ||
    window.location.pathname.includes("/kanban-view/") ||
    window.location.pathname.includes("/knowledge-base-enhancement/")
      ? "#F9FAFC"
      : window.location.pathname.includes("call-view") ||
        window.location.pathname.includes("dashboard")
      ? "#fff"
      : "#F4F6F8"};
`;

const CollapseIcon = styled.div`
  position: absolute;
  left: 17.5rem;
  top: 6.3rem;
  cursor: pointer;
  padding: 1rem;
  width: 3.2rem;
  height: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.6rem;
  background-color: transparent;
  transition: 0.2s all ease;
  z-index: 10;

  svg {
    user-select: none;
    height: 1.2rem;
    width: auto;
    object-fit: cover;
    transform: rotate(0deg);
    transition: 0.2s all ease;
  }

  &:hover {
    background-color: #919eab29;
    transition: 0.2s all ease;
  }

  &.collapsed {
    left: 3rem;
    top: 6.3rem;

    /* bottom: 1rem; */
    transition: 0.2s all ease;
    background-color: #ffffff;

    &:hover {
      background-color: #919eab29;
      transition: 0.2s all ease;
    }

    svg {
      transform: initial;
      transition: 0.2s all ease;
      transform: rotate(180deg);
    }
  }
`;

const CustomCol = styled(Col)`
  text-align: center;
  cursor: pointer;
  border-radius: 0.5rem;
  font-family: var(--roboto-400);
  font-size: 1.6rem;
  line-height: 2.2rem;
  color: #2c2c2c;
  transition: all 0.5s;
  &.version {
    padding: 0.6rem 0.8rem;
    margin-top: 0.8rem;
    font-family: var(--roboto-500);
    background-color: ${(props) => {
      const hex = props.theme.main.replace(/^#/, "");
      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;

      return `rgba(${r}, ${g}, ${b}, 0.15) !important`;
    }};
    color: ${(props) => props.theme.main} !important;
    transition: 0.2s all ease;

    &:hover {
      transition: 0.2s all ease;
      background-color: ${(props) => {
        const hex = props.theme.main.replace(/^#/, "");
        const bigint = parseInt(hex, 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;

        return `rgba(${r}, ${g}, ${b}, 0.25) !important`;
      }};
    }
  }
`;
